import { mdiAccountPlusOutline } from "@mdi/js";
import { useTheme } from "@mui/material";
import { MiModalConfirm } from "../../MiModalConfirm/MiModalConfirm";

interface RerunAutoAssignModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onAutoAssign: () => void;
  onClose: () => void;
}

export const RerunAutoAssignModal = ({
  isOpen,
  isLoading = false,
  onAutoAssign,
  onClose,
}: RerunAutoAssignModalProps) => {
  const theme = useTheme();

  return (
    <MiModalConfirm
      title="Re-run Auto Assign"
      titleIcon={{
        path: mdiAccountPlusOutline,
        color: theme.palette.primary.main,
      }}
      disableClick={isLoading}
      description="The order of work orders is not guaranteed after a manual assignment. To ensure that the work orders are arranged in the correct sequence, please rerun the Auto Assign process."
      open={isOpen}
      textPositive="Re-run Auto Assign"
      handleNegative={onClose}
      handlePositive={onAutoAssign}
    />
  );
};
